export default "/images/plus-icon.png?1d16dcaa95fa3ccc6da2d2a43a5b09f5";